// Workflow types as defined by the Frontend Configuration Service
// (workflows.jsonnet). Kept in one place so the value is referenced
// identically wherever a workflow's autopay capability is decided,
// guarding against literal drift between consumers.
export const WORKFLOW_TYPES = {
  DEFAULT: "default",
  OBLIGATION_ASSOCIATION: "obligation_association"
};
